import { render } from "./OrdersCount.vue?vue&type=template&id=26b949f7"
import script from "./OrdersCount.vue?vue&type=script&lang=js"
export * from "./OrdersCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__